module.exports = __webpack_public_path__ + "static/media/line-size-4.b2229445.svg";